import { AiChatButton as e } from "./components/ai-chat-button.mjs";
import { useWidgetControls as t } from "./hooks/use-widget-controlts.mjs";
import { Activity as n, Suspense as r, lazy as i, useState as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/modules/widget/ai-chat-widget-host.tsx
var c = i(() => import("./ai-chat-widget.mjs").then((e) => ({ default: e.AiChatWidget })));
function l(i) {
	let { open: l, setOpen: u } = t(), [d, f] = a(l), [p, m] = a(l);
	return l && !d && f(!0), l && !p && m(!0), /* @__PURE__ */ s("div", {
		className: "ai-chat-widget",
		children: [/* @__PURE__ */ o(e, { onClick: () => u((e) => !e) }), d && /* @__PURE__ */ o(n, {
			mode: p ? "visible" : "hidden",
			children: /* @__PURE__ */ o(r, {
				fallback: null,
				children: /* @__PURE__ */ o(c, {
					...i,
					open: l,
					onClose: () => u(!1),
					onCloseAnimationEnd: () => m(!1)
				})
			})
		})]
	});
}
//#endregion
export { l as AiChatWidgetHost };
